module.exports = __webpack_public_path__ + "assets/img/31_355.4eb0e498.jpg";